import Mutations from "./reports-mutations";
import Actions from "./reports-actions";
import Getters from "./reports-getters";
import DefaultState from "./reports-default-state";
export default {
  namespaced: true,
  state: DefaultState,
  mutations: Mutations,
  actions: Actions,
  getters: Getters
};